import routes from '@routes/config';

export default [{
    path: routes.client.index,
    name: routes.client.index,
    component: () => import(/* webpackChunkName: "Client" */  '@components/Client/Index')
}]
            